import { render, staticRenderFns } from "./ProcessExamingRec.vue?vue&type=template&id=6cd24d4d&scoped=true"
import script from "./ProcessExamingRec.vue?vue&type=script&lang=js"
export * from "./ProcessExamingRec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd24d4d",
  null
  
)

export default component.exports